// Cookies del Pixel de Meta (_fbp y _fbc). Son las que permiten que un evento
// enviado desde el servidor (Conversions API) se atribuya al clic del anuncio.
//
// El backend NO puede leerlas por su cuenta: viven en au-coaching.com y el backend
// está en au-coaching.onrender.com, así que el navegador no las manda cross-site.
// Por eso se leen acá y se envían en el body de la request.

import { getStoredAttribution } from './attribution';

function readCookie(name) {
  try {
    if (typeof document === 'undefined' || !document.cookie) return '';
    const match = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${name}=`));
    return match ? decodeURIComponent(match.slice(name.length + 1)) : '';
  } catch {
    return '';
  }
}

/**
 * Señales de Meta para mandar al backend junto con cualquier evento de conversión.
 * `fbclid` y `fbclid_at` van como respaldo: si el navegador no tiene la cookie _fbc
 * (bloqueador, o el Pixel todavía no cargó cuando entró), el backend la reconstruye.
 */
export function getMetaSignals() {
  const attribution = getStoredAttribution();
  return {
    fbp: readCookie('_fbp'),
    fbc: readCookie('_fbc'),
    fbclid: attribution.fbclid || '',
    fbclid_at: attribution.captured_at || 0,
  };
}

/** ID de evento compartido entre el Pixel y el CAPI para que Meta deduplique. */
export function newEventId(prefix = 'ev') {
  const rand = Math.random().toString(36).slice(2, 10);
  return `${prefix}_${Date.now()}_${rand}`;
}
